var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tariff-calculate', {
    attrs: {
      "products": _vm.products,
      "onLoadProfileRequests": _vm.fetchProfileRequests,
      "onCalculate": _vm.tariffCalculate,
      "tariffs": _vm.tariffs
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5266e5a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariffCalculate/TariffCalculateContainer.vue
// module id = 969
// module chunks = 0